import LegalPage from './LegalPage'

export default function CookiePolicy() {
  return (
    <LegalPage title="Cookie Policy">
      <h2>1. What Are Cookies</h2>
      <p>
        Cookies are small text files that are placed on your computer or mobile device 
        when you visit our website. They are widely used to make websites work more 
        efficiently and provide information to the website owners.
      </p>

      <h2>2. How We Use Cookies</h2>
      <p>
        We use cookies to:
      </p>
      <ul>
        <li>Remember your preferences and settings</li>
        <li>Understand how you use our website</li>
        <li>Improve our services</li>
        <li>Provide personalized content</li>
      </ul>

      <h2>3. Types of Cookies We Use</h2>
      <ul>
        <li>
          <strong>Essential Cookies:</strong> Required for the website to function properly
        </li>
        <li>
          <strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website
        </li>
        <li>
          <strong>Functional Cookies:</strong> Remember your preferences and settings
        </li>
        <li>
          <strong>Marketing Cookies:</strong> Track your visits to different websites
        </li>
      </ul>

      <h2>4. Managing Cookies</h2>
      <p>
        You can control and/or delete cookies as you wish. You can delete all cookies 
        that are already on your computer and you can set most browsers to prevent them 
        from being placed.
      </p>

      <h2>5. Changes to This Policy</h2>
      <p>
        We may update our Cookie Policy from time to time. We will notify you of any 
        changes by posting the new Cookie Policy on this page.
      </p>
    </LegalPage>
  )
}

